import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './style.css';
import { ContentProvider } from './contexts/ContentContext';
import useHashScroll from './hooks/useHashScroll';

import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Formations from './components/Formations';
import Experts from './components/Experts';
import Contact from './components/Contact';
import Admin from './components/admin/Admin';

// Layout component to wrap pages with Navigation and Footer
const Layout = ({ children }) => {
  // Add hash scrolling functionality to all pages
  useHashScroll();

  return (
    <div>
      <Navigation />
      <main>
        {children}
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <ContentProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/services" element={<Layout><Services /></Layout>} />
              <Route path="/formations" element={<Layout><Formations /></Layout>} />
          <Route path="/experts" element={<Layout><Experts /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Router>
    </ContentProvider>
  );
}

export default App;
